module.exports = __webpack_public_path__ + "media/images/marketing/focus2-d282619a096b79e98842bd6e190ee6115f96879d084ec12738b309383153eb3b.jpg";